import { render, staticRenderFns } from "./discovery.vue?vue&type=template&id=0147da5e&scoped=true&"
import script from "./discovery.vue?vue&type=script&lang=js&"
export * from "./discovery.vue?vue&type=script&lang=js&"
import style0 from "./discovery.vue?vue&type=style&index=0&id=0147da5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0147da5e",
  null
  
)

export default component.exports